import { ROLES } from "@/constants/roles";

export function hasFullFeatureAccess(userRole: string, isAdmin = false): boolean {
  return isAdmin || [ROLES.PREMIUM, ROLES.PLUS, ROLES.ADMIN, ROLES.TESTER].includes(userRole);
}

export function canAccessFeature(userRole: string, feature: string): boolean {
  switch (feature) {
    case 'visual-timers':
    case 'picture-schedules':
    case 'choice-boards':
      return [ROLES.LITE, ROLES.PREMIUM, ROLES.PLUS, ROLES.ADMIN, ROLES.TESTER].includes(userRole);

    case 'video-models':
    case 'social-narratives':
    case 'progress-tracking':
    case 'location-prep':
    case 'reminders':
    case 'reward-charts':
      return [ROLES.PREMIUM, ROLES.PLUS, ROLES.ADMIN, ROLES.TESTER].includes(userRole);

    case 'admin':
      return userRole === ROLES.ADMIN;

    case 'community-feed':
      return true; // Everyone can view; only Premium/Plus/Admin can add collaborators

    default:
      return false;
  }
}
